import React from 'react';
import UploaderComponent from '../components/Uploader';
import { AuthorisationConsumer } from '../../AuthorisationWrapper';






function Uploader(props) {
  return (
    <AuthorisationConsumer>
      {
      ({ selectedOrganisation: { organisationId } = {} }) =>
      <UploaderComponent organisationId={organisationId} {...props} />}


    </AuthorisationConsumer>);

}

export default Uploader;